<script>
    import blockUI from './BlockUIService.js';
    import moment from 'moment';
    import DataService from './DataService.js';
    import CryptoJS from 'crypto-js';
    export default {
        data() {
            return {
                loginDetails: '',

                


                Categories: [],
                Branches: [],
                Customers: [],
                Suppliers: [],
                PaymentsMethods: [],
                Stocking: [],

                Products: [],
                ProductsCounts: [],
                Users: [],

                
                
                

                
               


                //Cities: [],
                //Municipalities: [],
                //Locations: [],
                
                //PaymentsMethods: [],
                //Customers: [],
                //FromCustomers: [],
                //ToCustomers: [],


                //Distributors: [],

                /*Publeish*/
                ServerUrl: 'https://pharmaflow.moh.gov.ly',

                /*Local*/
                //ServerUrl: 'http://localhost:5000',
                Facebock: 'https://www.facebook.com/p/Traneem-100064940462078/?locale=ar_AR',
                Instagram: 'https://www.instagram.com/traneem5__/',
                TraneemPhone: '+218 94 457 81 48',
                TraneemEmail: 'info@traneem.ly',
                PlatFormPass: 'Traneem!@Platformv1',


                WebSiteName: 'PharmaFlow',
                BuildFor: '',
                logoPath: '/assets/img/1/logo.png',
                CoverPath: '/assets/img/illustrations/auth-register-illustration-dark.png',
                PdfPath: '/assets/img/icons/misc/pdf1.png',

            }
        },
        methods: {
            href(target) {
                if (!target || !this.$router) return;

                const resolved = this.$router.resolve(target);
                const targetRoute = resolved && resolved.route ? resolved.route : null;
                const currentFullPath = this.$route && this.$route.fullPath ? this.$route.fullPath : '';

                if (targetRoute && targetRoute.fullPath === currentFullPath) return;

                this.$router.push(target).catch((error) => {
                    if (!error || error.name !== 'NavigationDuplicated') {
                        throw error;
                    }
                });
            },
            openStockVoucher(voucher) {
                const voucherId = Number(voucher && voucher.id);
                if (!voucherId) return;

                this.href({
                    path: '/StockVouchers',
                    query: { id: String(voucherId) }
                });
            },
            permissionList() {
                if (!this.loginDetails || !this.loginDetails.permissions) return [];
                try {
                    const parsed = JSON.parse(this.loginDetails.permissions);
                    return Array.isArray(parsed) ? parsed : [];
                } catch {
                    return [];
                }
            },
            hasUiPermission(key) {
                if (!key) return false;
                const list = this.permissionList();
                return list.includes('*') || list.some((x) => String(x).toLowerCase() === String(key).toLowerCase());
            },
            hasUiPermissionPrefix(prefix) {
                if (!prefix) return false;
                const list = this.permissionList();
                return list.some((x) => String(x).toLowerCase().startsWith(String(prefix).toLowerCase()));
            },
            /** نوع المستخدم كرقم — يُجنّب فشل المقارنة عند وصول userType كنص من التخزين أو الـ API. */
            loginUserTypeNumber() {
                if (!this.loginDetails || this.loginDetails.userType === null || this.loginDetails.userType === undefined || this.loginDetails.userType === '')
                    return NaN;
                const n = Number(this.loginDetails.userType);
                return Number.isFinite(n) ? n : NaN;
            },
            isSupportedPortalUser() {
                const t = this.loginUserTypeNumber();
                return !!(this.loginDetails && [1, 2, 3, 4, 5, 6, 40, 50].includes(t));
            },
            isAdministratorRole() {
                return this.loginUserTypeNumber() === 1;
            },
            hasAdministratorOperationalAccessUi() {
                return this.isAdministratorRole() || this.isMinistryPharmacyDepartmentRole();
            },
            canManageSystemUsersUi() {
                // مدير النظام، أو مكتب تقنية المعلومات: وزاري (40) بمفتاح system_users.manage صريح
                return this.isAdministratorRole()
                    || (this.isMinistryUserRole() && this.hasUiPermission('system_users.manage'));
            },
            /**
             * حساب مكتب تقنية المعلومات «المتخصص»: وزاري (40) صلاحياته system_users.manage فقط.
             * تُخفى عنه القوائم التشغيلية (على نمط استثناء minister_dashboard.access).
             * لو مُنح مفاتيح إضافية مستقبلاً يعود لسلوك المستخدم الوزاري المعتاد.
             */
            isItOfficeOnlyUi() {
                if (!this.isMinistryUserRole()) return false;
                const list = this.permissionList();
                return list.length > 0
                    && list.every((x) => String(x).toLowerCase() === 'system_users.manage');
            },
            isMinistryUserRole() {
                return this.loginUserTypeNumber() === 40;
            },
            isMinistryPharmacyDepartmentRole() {
                return this.loginUserTypeNumber() === 4;
            },
            isFacilityEmployeeRole() {
                return this.loginUserTypeNumber() === 2;
            },
            isFacilitySubordinateRole() {
                return this.loginUserTypeNumber() === 5;
            },
            isFacilityDepartmentManagerRole() {
                return this.loginUserTypeNumber() === 6;
            },
            /** مرؤوس مركز (5) أو مسؤول قسم مرفق (6) — التحقق من صلاحيات JSON */
            usesFacilityPermissionUi() {
                return this.isFacilitySubordinateRole() || this.isFacilityDepartmentManagerRole();
            },
            isFacilityCenterRole() {
                return this.isFacilityEmployeeRole() || this.isFacilitySubordinateRole() || this.isFacilityDepartmentManagerRole();
            },
            hasInventoryAndStockAccessUi() {
                return this.isAdministratorRole() || this.isMinistryUserRole() || this.isMinistryPharmacyDepartmentRole();
            },
            canReviewMedicineOrdersUi() {
                return this.isAdministratorRole() || this.isMinistryPharmacyDepartmentRole();
            },
            canReviewProcurementRequestsUi() {
                return this.isAdministratorRole() || this.isMinistryUserRole() || this.isMinistryPharmacyDepartmentRole();
            },
            canCreateMedicineOrdersUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('medicine_orders.create');
                return false;
            },
            canViewMedicineOrdersUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi() || this.isMinistryPharmacyDepartmentRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('medicine_orders.view') || this.hasUiPermission('medicine_orders.create');
                return false;
            },
            /** تحويل طلب مرافق معتمد إلى عملية صرف — مدير النظام أو مستخدم وزاري (المخازن). */
            canConvertMedicineOrderToDispatchUi() {
                return !!(this.loginDetails && (this.hasInventoryAndStockAccessUi()));
            },
            /** طلب تعديل (الصيدلة) — نفس صلاحية المراجعة. */
            canRequestMedicineOrderModificationUi() {
                return this.canReviewMedicineOrdersUi();
            },
            canViewReceiptVerificationsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi() || this.isMinistryPharmacyDepartmentRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('receipt_verification.view') || this.hasUiPermission('receipt_verification.verify');
                return false;
            },
            canVerifyReceiptsUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('receipt_verification.verify');
                return false;
            },
            canViewReturnOrdersUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi() || this.isMinistryPharmacyDepartmentRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('return_orders.view') || this.hasUiPermission('return_orders.create');
                return false;
            },
            canCreateReturnOrdersUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('return_orders.create');
                return false;
            },
            /** مراقبة الصرف للمرضى — مسؤول النظام وإدارة الصيدلة (طلب الإدارة 2026-10-07). اطلاع فقط. */
            canMonitorPatientDispensesUi() {
                if (!this.loginDetails) return false;
                return this.isAdministratorRole() || this.isMinistryPharmacyDepartmentRole();
            },
            canViewDamageReportsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi() || this.isMinistryPharmacyDepartmentRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('damage_reports.view') || this.hasUiPermission('damage_reports.create');
                return false;
            },
            canCreateDamageReportsUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('damage_reports.create');
                return false;
            },
            canViewStockVouchersUi() {
                return !!(this.loginDetails && (this.hasInventoryAndStockAccessUi() || this.isMinistryPharmacyDepartmentRole() || this.isFacilityCenterRole()));
            },
            canViewFacilityDepartmentsUi() {
                if (!this.loginDetails) return false;
                if (this.hasAdministratorOperationalAccessUi() || this.isMinistryUserRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return this.hasUiPermission('facility_departments.view')
                        || this.hasUiPermission('facility_departments.manage')
                        || this.hasUiPermission('facility_departments.issue')
                        || this.hasUiPermissionPrefix('facility_departments.issue.department.');
                }
                return false;
            },
            canManageFacilityDepartmentsUi() {
                if (!this.loginDetails) return false;
                if (this.hasAdministratorOperationalAccessUi() || this.isMinistryUserRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('facility_departments.manage');
                return false;
            },
            canIssueToFacilityDepartmentsUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return this.hasUiPermission('facility_departments.issue')
                        || this.hasUiPermissionPrefix('facility_departments.issue.department.');
                }
                return false;
            },
            canViewNonFormularyRequestsUi() {
                if (!this.loginDetails) return false;
                if (this.canReviewProcurementRequestsUi()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('non_formulary.view') || this.hasUiPermission('non_formulary.create');
                return false;
            },
            canCreateNonFormularyRequestsUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('non_formulary.create');
                return false;
            },
            canViewProductAdditionRequestsUi() {
                if (!this.loginDetails) return false;
                if (this.canReviewProductAdditionRequestsUi()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return this.hasUiPermission('product_addition.view') || this.hasUiPermission('product_addition.create');
                }
                return false;
            },
            canCreateProductAdditionRequestsUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('product_addition.create');
                return false;
            },
            canReviewProductAdditionRequestsUi() {
                if (!this.loginDetails) return false;
                return this.hasInventoryAndStockAccessUi() || this.canReviewProcurementRequestsUi();
            },
            canViewNationalFormularyPortfolioUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi() || this.canReviewProcurementRequestsUi()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return this.hasUiPermission('national_formulary_portfolio.view')
                        || this.hasUiPermission('national_formulary_portfolio.request');
                }
                return false;
            },
            canRequestNationalFormularyPortfolioUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('national_formulary_portfolio.request');
                return false;
            },
            canManageNationalFormularyPortfolioGrantsUi() {
                return !!(this.loginDetails && (this.hasInventoryAndStockAccessUi() || this.canReviewProcurementRequestsUi()));
            },
            /** إدارة القائمة النمطية الوطنية — مدير النظام أو مستخدم وزاري */
            canManageNationalFormularyUi() {
                return !!(this.loginDetails && this.hasInventoryAndStockAccessUi());
            },
            /** إنشاء بند تخصصي خارج القائمة النمطية — مدير النظام أو قسم الصيدلة */
            canCreateOutsideFormularyItemUi() {
                return !!(this.loginDetails && this.hasAdministratorOperationalAccessUi());
            },
            /** مراجعة مقترحات القائمة النمطية صيدلانياً — قسم الصيدلة (4) */
            canPharmacyReviewFormularyUi() {
                return !!(this.loginDetails && this.isMinistryPharmacyDepartmentRole());
            },
            /** الاعتماد النهائي لبند قائمة نمطية — مدير النظام أو مستخدم وزاري */
            canApproveFormularyItemUi() {
                return !!(this.loginDetails && this.hasInventoryAndStockAccessUi());
            },
            /** يرى شاشة مراجعة/اعتماد القائمة النمطية — أي مستخدم وزاري أو صيدلة */
            canViewFormularyReviewUi() {
                return !!(this.loginDetails && (this.hasInventoryAndStockAccessUi() || this.isMinistryPharmacyDepartmentRole()));
            },
            /** مستخدم وزاري يمكنه الصرف المركزي — مدير النظام أو وزاري */
            canDispenseFromMinistryUi() {
                return !!(this.loginDetails && this.hasInventoryAndStockAccessUi());
            },
            canViewExternalPurchaseRequestsUi() {
                if (!this.loginDetails) return false;
                // المرفق يرى طلباته، والإدارة تراجع الكل.
                return this.isFacilityEmployeeRole() || this.canReviewProcurementRequestsUi();
            },
            /* صرف الدواء للمريض — موظف المرفق (2) مسموح افتراضياً لأن حسابه هو الحساب
               الوحيد للمرفق حالياً؛ ومستخدمو الأقسام (5/6) بمفاتيح الصلاحيات. */
            canViewPatientDispensesUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return this.hasUiPermission('patient_dispense.view')
                        || this.canDispenseToPatientsUi();
                }
                return false;
            },
            canDispenseToPatientsUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return this.hasUiPermission('patient_dispense.create')
                        || this.hasUiPermissionPrefix('patient_dispense.department.');
                }
                return false;
            },
            canCancelPatientDispenseUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('patient_dispense.cancel');
                return false;
            },
            canCreateExternalPurchaseRequestsUi() {
                if (!this.loginDetails) return false;
                // طلب الشراء المباشر ينشئه المرفق الصحي نفسه.
                return this.isFacilityEmployeeRole() || this.hasInventoryAndStockAccessUi();
            },
            canViewSurplusRequestsUi() {
                if (!this.loginDetails) return false;
                if (this.canReviewProcurementRequestsUi()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('surplus_requests.view') || this.hasUiPermission('surplus_requests.create');
                return false;
            },
            canCreateSurplusRequestsUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('surplus_requests.create');
                return false;
            },
            canViewRotationTransfersUi() {
                if (!this.loginDetails) return false;
                if (this.canReviewProcurementRequestsUi() || this.hasInventoryAndStockAccessUi()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('rotation_transfers.view') || this.hasUiPermission('rotation_transfers.receive');
                return false;
            },
            canReceiveRotationTransfersUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('rotation_transfers.receive');
                return false;
            },
            canViewInventoryCountsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi() || this.isMinistryPharmacyDepartmentRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return (
                        this.hasUiPermission('inventory_counts.view') ||
                        this.hasUiPermission('inventory_counts.create') ||
                        this.hasUiPermission('inventory_counts.warehouse_lines') ||
                        this.hasUiPermission('inventory_counts.approve') ||
                        this.hasUiPermission('inventory_counts.department_lines') ||
                        this.hasUiPermissionPrefix('facility_departments.issue.department.')
                    );
                }
                return false;
            },
            canCreateInventoryCountsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return this.hasUiPermission('inventory_counts.create') || this.hasUiPermission('inventory_counts.warehouse_lines');
                }
                return false;
            },
            canSubmitInventoryCountSessionUi() {
                return this.canCreateInventoryCountsUi();
            },
            canApproveInventoryCountsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('inventory_counts.approve');
                return false;
            },
            canWarehouseInventoryLinesUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return this.hasUiPermission('inventory_counts.warehouse_lines') || this.hasUiPermission('inventory_counts.create');
                }
                return false;
            },
            canDepartmentInventoryLinesUi() {
                if (!this.loginDetails || !this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return false;
                if (!this.inventoryAllowedDepartmentIdsUi.length) return false;
                if (this.isFacilityDepartmentManagerRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('inventory_counts.department_lines');
                return false;
            },
            inventoryAllowedDepartmentIdsUi() {
                const list = this.permissionList();
                const prefix = 'facility_departments.issue.department.';
                return list
                    .filter((x) => x && String(x).indexOf(prefix) === 0)
                    .map((x) => Number(String(x).replace(prefix, '')))
                    .filter((x) => Number.isFinite(x) && x > 0);
            },
            /** فلتر القسم في شاشة الجرد — يظهر لمدير المرفق/أمين المخزن حتى قبل تحميل UiContext. */
            showDepartmentFilterUi() {
                if (this.invUi && this.invUi.showDepartmentFilter != null) {
                    return !!this.invUi.showDepartmentFilter;
                }
                return this.isFacilityEmployeeRole() || this.hasInventoryAndStockAccessUi() || this.canWarehouseInventoryLinesUi();
            },
            canViewInventoryAlertsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi() || this.isMinistryPharmacyDepartmentRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('inventory_alerts.view') || this.hasUiPermission('inventory_counts.view');
                return false;
            },
            /** صلاحية رؤية صفحة تقارير المخزون (/StockReports). */
            canViewStockReportsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi() || this.isMinistryPharmacyDepartmentRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) {
                    return this.hasUiPermission('inventory_alerts.view')
                        || this.hasUiPermission('inventory_counts.view')
                        || this.hasUiPermission('inventory_counts.create')
                        || this.hasUiPermission('inventory_counts.warehouse_lines')
                        || this.hasUiPermission('inventory_counts.department_lines');
                }
                return false;
            },
            /** صلاحية تصدير وطباعة تقارير المخزون.
             *  ✓ وزارة الصحة / إدارة المخازن (نوع 1، 40)
             *  ✓ إدارة الصيدلة (4) — يُعرض ولكن بدون تصدير حسب المتطلبات الرسمية
             *      نُتيحه هنا أيضًا لأنّ بيانات التقرير عامة على كل المرافق.
             *  ✓ مدير/أمين مرفق (2 وكذلك صلاحية «الجرد والمخزون») — مرفقه فقط
             *  ✗ مسؤول قسم (6) — مشاهدة فقط بلا تصدير
             */
            canExportStockReportsUi() {
                if (!this.canViewStockReportsUi()) return false;
                if (this.isFacilityDepartmentManagerRole()) return false;
                return true;
            },
            canUseNotificationsUi() {
                if (!this.loginDetails) return false;
                if (this.isAdministratorRole() || this.isMinistryUserRole() || this.isMinistryPharmacyDepartmentRole()) return true;
                if (!this.loginDetails.branchesId) return false;
                if (this.isFacilityEmployeeRole()) return true;
                if (this.usesFacilityPermissionUi()) return this.hasUiPermission('notifications') || this.hasUiPermission('medicine_orders.create');
                return false;
            },
            canViewStockingsUi() {
                return !!(this.loginDetails && (this.hasInventoryAndStockAccessUi() || this.isFacilityCenterRole()));
            },
            canManageStockingsUi() {
                return this.hasInventoryAndStockAccessUi();
            },
            canViewWarehouseMovementsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi()) return true;
                return !!(this.isFacilityCenterRole() && this.loginDetails.branchesId);
            },
            /**
             * صلاحية رؤية واجهة حركات المخزون الجديدة (/Warehouse/StockMovements).
             * الصلاحيات: وزارة الصحة + إدارة الصيدلة + مدراء/أمناء المرافق على مرفقهم.
             */
            canViewStockMovementsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi()) return true;
                if (this.isMinistryPharmacyDepartmentRole()) return true;
                return !!(this.isFacilityCenterRole() && this.loginDetails.branchesId);
            },
            /**
             * صلاحية طباعة سند الحركة.
             */
            canPrintStockMovementsUi() {
                return this.canViewStockMovementsUi();
            },
            canViewFinancialUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi()) return true;
                return !!(this.isFacilityCenterRole() && this.loginDetails.branchesId);
            },
            canViewBranchUsersUi() {
                return this.isFacilityEmployeeRole() || this.isFacilityDepartmentManagerRole()
                    || this.canCreateBranchUsersUi();
            },
            /** مسؤول المرفق فقط — يطابق UserRoles.CanManageFacilityUsers في الخادم. */
            canManageBranchUsersUi() {
                return this.isFacilityEmployeeRole();
            },
            isMinistryStockAdminUi() {
                return !!(this.loginDetails && this.hasInventoryAndStockAccessUi());
            },
            guardAdministratorOperationalPage() {
                if (!this.loginDetails || !this.hasAdministratorOperationalAccessUi()) {
                    this.logout();
                    return false;
                }
                return true;
            },
            guardInventoryStockPage() {
                if (!this.loginDetails || !this.hasInventoryAndStockAccessUi()) {
                    this.logout();
                    return false;
                }
                return true;
            },
            guardSystemUsersPage() {
                if (!this.loginDetails || !this.canManageSystemUsersUi()) {
                    this.logout();
                    return false;
                }
                return true;
            },
            /**
             * إنشاء حسابات مستخدمي المرافق والأقسام: مدير النظام وإدارة الصيدلة حصراً
             * — يطابق UserRoles.CanCreateFacilityUsers في الخادم (قرار العميل 2026-09-28).
             * وسُحب الإنشاء وحده: مسؤول المرفق يبقى يعدّل مرؤوسيه ويصفّر كلماتهم
             * ويوقفهم عبر canManageBranchUsersUi.
             */
            canCreateBranchUsersUi() {
                return this.isAdministratorRole() || this.isMinistryPharmacyDepartmentRole();
            },
            /** صلاحية رؤية شاشة "التقارير الشاملة" (/ComprehensiveReports).
             *  ✓ وزارة الصحة + إدارة المخازن + إدارة الصيدلة (1، 40، 4)
             *  ✓ مدير/أمين مرفق (نطاق مرفقه فقط — يطبَّق في الـ backend)
             */
            canViewComprehensiveReportsUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi()) return true;
                if (this.isMinistryPharmacyDepartmentRole()) return true;
                if (this.isFacilityCenterRole() && this.loginDetails.branchesId) return true;
                return false;
            },
            /** صلاحية رؤية شاشة "السندات الرسمية الموحَّدة" (/OfficialVouchers).
             *  ✓ وزارة الصحة + إدارة المخازن (1، 40)
             *  ✓ إدارة الصيدلة (4)
             *  ✓ مدير/أمين مرفق (سندات مرفقه فقط) — Backend يطبّق التقييد
             */
            canViewOfficialVouchersUi() {
                if (!this.loginDetails) return false;
                if (this.hasInventoryAndStockAccessUi()) return true;
                if (this.isMinistryPharmacyDepartmentRole()) return true;
                if (this.isFacilityCenterRole() && this.loginDetails.branchesId) return true;
                return false;
            },
            /** صلاحية رؤية لوحة مراجعة الصيدلة (Pharmacy Dashboard).
             *  ✓ قسم الصيدلة بالوزارة (4) — مراجعة كاملة.
             *  ✓ مدير النظام (1) ومستخدم وزاري (40) — عرض كامل.
             *  ✗ باقي المستخدمين (مرفقي/قسم/مورد) — لا.
             */
            canViewPharmacyDashboardUi() {
                if (!this.loginDetails) return false;
                if (this.isMinistryPharmacyDepartmentRole()) return true;
                if (this.isAdministratorRole()) return true;
                if (this.hasInventoryAndStockAccessUi()) return true;
                return false;
            },
            canManageWorkflowDefinitionsUi() {
                return this.hasAdministratorOperationalAccessUi();
            },

            encrypt: function encrypt(data, SECRET_KEY) {
                var dataSet = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY);
                dataSet = dataSet.toString();
                return dataSet;
            },
            decrypt: function decrypt(data, SECRET_KEY) {
                data = CryptoJS.AES.decrypt(data, SECRET_KEY);
                data = JSON.parse(data.toString(CryptoJS.enc.Utf8));
                return data;
            },

            ClearForm(ruleForm) {
                for (const key in ruleForm) {
                    if (Array.isArray(ruleForm[key])) {
                        ruleForm[key] = []; // Reset to an empty array if it's an array
                    } else {
                        ruleForm[key] = ''; // Reset to an empty string for other types
                    }
                }
            },

            async CheckLoginStatus() {
                try {
                    this.loginDetails = JSON.parse(this.decrypt(localStorage.getItem('currentUser-client'), this.PlatFormPass));
                    const res = await DataService.IsLoggedin();
                    if (!res.data)
                        this.logout();
                } catch (error) {
                    this.logout();
                }
            },

            async logout() {
                localStorage.removeItem('currentUser-client');
                localStorage.clear();
                document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
                
                this.$http.Logout()
                    .then(() => {
                        window.location.href = "/";
                    })

                window.location.href = "/";
            },


            formatNumber(num) {
                if (num) {
                    if (num <= 0) {
                        return 0;
                    } else {
                        return new Intl.NumberFormat('en-US').format(num); // Format the number
                    }
                } else {
                    return 0;
                }
            },

            statCard(title, value, tone = 'primary', icon = 'ti ti-chart-bar', subtitle = '') {
                return {
                    title,
                    value: Number(value || 0),
                    tone,
                    icon,
                    subtitle
                };
            },

            countWhere(items, predicate) {
                if (!Array.isArray(items) || typeof predicate !== 'function') {
                    return 0;
                }

                return items.filter(predicate).length;
            },

            sumWhere(items, selector) {
                if (!Array.isArray(items) || typeof selector !== 'function') {
                    return 0;
                }

                return items.reduce((sum, item) => {
                    const value = Number(selector(item) || 0);
                    return sum + (isNaN(value) ? 0 : value);
                }, 0);
            },

            matchStatus(item, values = [], labels = []) {
                if (!item) {
                    return false;
                }

                const numericValues = Array.isArray(values)
                    ? values.map(x => Number(x))
                    : [Number(values)];
                const normalizedLabels = (Array.isArray(labels) ? labels : [labels])
                    .filter(x => x !== null && x !== undefined && x !== '')
                    .map(x => String(x).toLowerCase());

                const itemStatus = Number(item.status);
                const itemLabel = String(item.statusLabel || '').toLowerCase();

                if (!isNaN(itemStatus) && numericValues.some(x => !isNaN(x) && x === itemStatus)) {
                    return true;
                }

                return normalizedLabels.some(label => itemLabel.includes(label));
            },

            // ── تواريخ الصلاحية (طلب العميل 2026-10-05: «النظام ميقبلش يدخل غلط تاريخ») ──
            // نفس نافذة الخادم (ExpiryPolicy): من 2000 حتى اليوم + 30 سنة. الخادم هو الضمان؛
            // هذه لتظهر المشكلة للمستخدم لحظة الإدخال لا بعد الحفظ.
            // حقل <input type="date"> يحوّل السنة المكتوبة برقمين إلى 0028 ويحدّث القيمة مع كل حرف،
            // فالفحص قبل الإرسال ضروري ولا يكفي min/max وحدهما.
            expiryMinDate() {
                return '2000-01-01';
            },
            expiryMaxDate() {
                return moment().add(30, 'years').format('YYYY-MM-DD');
            },
            /** رسالة المشكلة في التاريخ أو null. label: اسم الحقل في الرسالة. */
            expiryDateProblem(value, itemName, label) {
                if (value === null || value === undefined || value === '') return null;
                const text = String(value).slice(0, 10);
                const m = /^(\d{1,6})-(\d{2})-(\d{2})$/.exec(text);
                const what = label || 'تاريخ الصلاحية';
                const subject = itemName ? ` للصنف ${itemName}` : '';
                if (!m) return `${what}${subject} غير صحيح.`;
                const year = Number(m[1]);
                if (text >= this.expiryMinDate() && text <= this.expiryMaxDate() && m[1].length === 4) return null;
                let hint = ' — تحقق من السنة (أربعة أرقام)';
                if (year < 100) hint = ` — هل قصدت ${String(2000 + year)}-${m[2]}-${m[3]}؟`;
                else if (year >= 1900 && year < 2000) hint = ` — هل قصدت ${String(year + 100)}-${m[2]}-${m[3]}؟`;
                return `${what} ${text}${subject} غير معقول${hint}`;
            },
            /** خيارات el-date-picker: تمنع الأيام خارج النافذة نقراً وكتابةً. */
            expiryPickerOptions() {
                const min = this.expiryMinDate();
                const max = this.expiryMaxDate();
                return {
                    disabledDate(d) {
                        const s = moment(d).format('YYYY-MM-DD');
                        return s < min || s > max;
                    },
                };
            },
            moment(date) {
                if (date === null) {
                    return "------";
                }
                // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                return moment(date).format('DD/MM/YYYY');
            },

            momentTime (date) {
                if (date === null) {
                    return "------";
                }
                // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                return moment(date).format('DD/MM/YYYY ||  h:mm a');
            },

            momentYear(date) {
                if (date === null) {
                    return "------";
                }
                // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                return moment(date).format('YYYY-MM');
            },

            ChangeDate(date) {
                    if (date === null) {
                        return "فارغ";
                    }
                    return moment(date).format("YYYY-MM-DD");
            },

            GetTodayDate() {
                const today = new Date();
                // Format date as YYYY-MM-DD
                const year = today.getFullYear();
                const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
                const day = today.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            },



            async GetAllStocking() {
                this.Stocking = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllStocking();
                    this.Stocking = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllCategories() {
                this.Categories = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllCategories();
                    this.Categories = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllBranches() {
                this.Branches = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllBranches();
                    this.Branches = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllCustomers() {
                this.Customers = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllCustomers();
                    this.Customers = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllSuppliers() {
                this.Suppliers = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllSuppliers();
                    this.Suppliers = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllProducts() {
                this.Products = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllProducts();
                    this.Products = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllProductsCounts() {
                this.ProductsCounts = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllProductsCounts();
                    this.ProductsCounts = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllPaymentsMethods() {
                this.PaymentsMethods = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllPaymentsMethods();
                    this.PaymentsMethods = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllUsers() {
                this.Users = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllUsers();
                    this.Users = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },




           
        }
    }
</script>
